var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('w-json-viewer-group',{attrs:{"value":_vm.value,"open":"","is-last-item":"","hide-key":"","is-root":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }